import React, { useEffect, useState } from "react";
import Big from "big.js";
import { useDebounce } from "react-use";
import { NumberFormatValues, SourceInfo } from "react-number-format";
import { useTranslation } from "react-i18next";
import { SInputContainer, SInputField, SLabel } from "./styles";
import { useInitialApplication } from "../../../store";
import { CurrencyInput } from "..";

export const ApplicationAmount: React.FC = () => {
  const { t } = useTranslation();
  const [localApplicationAmount, setLocalApplicationAmount] = useState(100);
  const { initialApplication, setInitialApplication } = useInitialApplication();

  const handleChange = (
    maskedInputValue: NumberFormatValues,
    sourceInfo: SourceInfo
  ): void => {
    // onValueChange is called on EVERY change (unlike onChange) not only on events.
    // When value is fully deleted by the user, sourceinfo.source equals to "props" and not "event"
    if (
      sourceInfo.source === "event" ||
      (sourceInfo.source === "prop" && maskedInputValue.floatValue === 0)
    ) {
      setLocalApplicationAmount(maskedInputValue.floatValue || 0);
    }
  };

  useDebounce(
    () => {
      if (localApplicationAmount !== initialApplication) {
        setInitialApplication(Big(localApplicationAmount).toNumber());
      }
    },
    1250,
    [localApplicationAmount]
  );

  useEffect(() => {
    setLocalApplicationAmount(initialApplication);
  }, [initialApplication]);

  return (
    <SInputContainer>
      <SLabel>{t("applicationAmount.initialApplication")}</SLabel>
      <CurrencyInput
        onValueChange={handleChange}
        value={Big(localApplicationAmount).round(2).toNumber()}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        customInput={SInputField}
        disableUnderline
      />
    </SInputContainer>
  );
};
